if (!customElements.get('product-expectation-hover')) {
  customElements.define(
    'product-expectation-hover',
    class ProductExpectationHover extends HTMLElement {
      isAnimating = false;
      animationFrameId = null;
      mouseOverEvent = null;

      get mouseHoverElements() {
        return this.querySelectorAll('.product-expectation-progress--track');
      }

      get mouseHoverCards() {
        return this.querySelectorAll('.expectation-card');
      }

      constructor() {
        super();
        this.mouseHoverEvent = this.handleMouseHoverEvent.bind(this);
        this.mouseHoverProgress = this.handleMouseHoverProgress.bind(this);
        this.throttleMouseHoverProgress = throttle(this.mouseHoverProgress, 10);
      }

      connectedCallback() {
        document.addEventListener('mouseover', this.mouseHoverEvent);
      }

      disconnectedCallback() {
        document.removeEventListener('mouseover', this.mouseHoverEvent);
      }

      handleMouseHoverEvent(event) {
        if (!this.contains(event.target)) {
          this.resetActiveBoxs();
          return;
        };

        this.mouseOverEvent = event;
        this.throttleMouseHoverProgress(event);
      }

      handleMouseHoverProgress(event) {
        if (!this.isAnimating && this.mouseHoverElements.length) this.startAnimationFrame();
      }

      startAnimationFrame() {
        this.isAnimating = true;
        const animate = () => {
          const rect = this.getBoundingClientRect();
          this.handleMouseOverAnimation(this.mouseOverEvent);

          // Request the next animation frame
          this.animationFrameId = requestAnimationFrame(animate);

          // Auto stop animation frame if not needed
          const autoStopAnimation = rect.bottom < window.innerHeight || rect.top > window.innerHeight;
          autoStopAnimation && this.isAnimating && this.stopAnimationFrame();
        };
        animate();
      }

      stopAnimationFrame() {
        if (this.animationFrameId) {
          cancelAnimationFrame(this.animationFrameId);
          this.animationFrameId = null;
          this.isAnimating = false;
        }
      }

      handleMouseOverAnimation(event) {
        let hoveredIndex = -1;
        for (let i = 0; i < this.mouseHoverElements.length; i++) {
          const elParent = this.mouseHoverElements[i].closest('.product-expectation-card');
          if (elParent && elParent.contains(event.target)) {
            hoveredIndex = i;
            break;
          }
        }

        for (let i = 0; i < this.mouseHoverCards.length; i++) {
          const el = this.mouseHoverElements[i];
          const elParent = el.closest('.product-expectation-card');

          if (hoveredIndex !== -1 && i !== 0 && elParent) {
            this.toggleActive(elParent, 'active', i <= hoveredIndex);
            // setTimeout(() => {
            //   this.toggleActive(elParent, 'active', i <= hoveredIndex);
            // }, (i - 1) * 1000);
          };
        }
      }

      toggleActive(el, activeClass, active = true) {
        active ? !el.classList.contains(activeClass) && el.classList.add(activeClass) : el.classList.contains(activeClass) && el.classList.remove(activeClass);
      }

      resetActiveBoxs() {
        this.mouseHoverElements.forEach((el, index) => {
          const elParent = el.closest('.product-expectation-card');
          if (index !== 0) this.toggleActive(elParent, 'active', false);
        })
      }

      updateActiveCard(cardEl) {
        cardEl.classList.add('active-box');
        Array.from(this.mouseHoverCards)?.filter(item => item !== cardEl).forEach(el => el.classList.remove('active-box'));
      }
    }
  )
}


if (!customElements.get('scroll-product-expectation')) {
  customElements.define(
    'scroll-product-expectation',
    class ScrollProductExpectation extends ScrollProgress {
      spaceEven = false;
      prevScroll = null;

      get scrollElements() {
        return this.querySelectorAll('.product-expectation--mobile .expectation-card--track-progress');
      }

      constructor() {
        super();
        this.throttleScrollProgress = throttle(this.scrollProgress, 10);
      }

      connectedCallback() {
        this.handleScrollAnimation();
        document.addEventListener('scroll', this.scrollEvent);
        window.addEventListener('DOMContentLoaded', () => this.handleScrollAnimation());
      }

      disconnectedCallback() {
        document.removeEventListener('scroll', this.scrollEvent);
        this.stopAnimationFrame();
      }

      handleScrollEvent(event) {
        if (!this.scrollElements.length) return;
        this.throttleScrollProgress();
      }

      handleScrollAnimation() {
        if (!this.scrollElements.length) return;

        for (let i = 0; i < this.scrollElements.length; i++) {
          const imageTrRect = this.scrollElements[i].getBoundingClientRect();

          let scrollProgressStart = imageTrRect.top < (window.innerHeight / 2);
          let scrollProgressEnd = imageTrRect.top < (window.innerHeight / 2) - imageTrRect.height;
          let scrollProgressReverseStart = imageTrRect.top > (window.innerHeight / 2) - imageTrRect.height;
          let scrollProgressReverseEnd = imageTrRect.top > (window.innerHeight / 2);

          if (scrollProgressReverseEnd && this.scrollElements[i].classList.contains('scroll-progress-active')) {
            this.scrollElements[i].classList.remove('scroll-progress--running'), this.scrollElements[i].classList.remove('scroll-progress-active');
          }

          if (scrollProgressReverseStart && this.scrollElements[i].classList.contains('scroll-progress-active')) {
            this.scrollElements[i].classList.remove('scroll-progress--finished'), this.scrollElements[i].classList.add('scroll-progress--running');
          }

          if (scrollProgressEnd && this.scrollElements[i].classList.contains('scroll-progress-active')) {
            this.scrollElements[i].classList.remove('scroll-progress--running'), this.scrollElements[i].classList.add('scroll-progress--finished');
          }

          if (scrollProgressStart && !this.scrollElements[i].classList.contains('scroll-progress-active')) {
            this.scrollElements[i].classList.add('scroll-progress-active'), this.scrollElements[i].classList.add('scroll-progress--running');
          }

          // progress bar transition
          if (imageTrRect.top < (window.innerHeight / 2) && imageTrRect.top > (window.innerHeight / 2) - imageTrRect.height) {
            // Calculate progress (0 at start, 1 at end)
            const start = window.innerHeight / 2;
            const end = (window.innerHeight / 2) - imageTrRect.height;
            const progress = (start - imageTrRect.top) / (start - end);

            // Clamp progress between 0 and 1
            const clampedProgress = Math.max(0, Math.min(1, progress));

            // Interpolate scale and opacity
            const clip = 100 - ((0 + (1 - 0) * clampedProgress) * 100);

            // Apply styles
            this.scrollElements[i].style.clipPath = `inset(0% 0% ${clip.toFixed(2)}% 0%)`;
          }

          if (imageTrRect.top < (window.innerHeight / 2) - imageTrRect.height) {
            this.scrollElements[i].style.clipPath = `inset(0% 0% 0% 0%)`;
          }

          if (imageTrRect.top > (window.innerHeight / 2)) {
            this.scrollElements[i].style.clipPath = `inset(0% 0% 100% 0%)`;
          }
        }
      }
    }
  )
}